import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface LevelAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  level_index: number;
  level_name?: string;
  tenant: OD3_Tenant;
}

export class Level extends Parse.Object<LevelAttributes> {
  static className: string = "OD3_GTFS_Level";

  constructor(data?: Partial<LevelAttributes>) {
    super("OD3_GTFS_Level", data as LevelAttributes);
  }

  get level_index(): number {
    return super.get("level_index");
  }
  set level_index(value: number) {
    super.set("level_index", value);
  }
  get level_name(): string | undefined {
    return super.get("level_name");
  }
  set level_name(value: string | undefined) {
    super.set("level_name", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Level", Level);
